import React from "react";
import "../../Assessts/Styles/Teams.scss";
import { Images } from "../../ReUableComponents/CommonElements";

import NCT1 from "../../Assessts/Images/AboutUs/Coreteam/NCT1.png";
import NCT2 from "../../Assessts/Images/AboutUs/Coreteam/NCT2.png";
import NCT3 from "../../Assessts/Images/AboutUs/Coreteam/NCT3.png";
import NCT4 from "../../Assessts/Images/AboutUs/Coreteam/NCT4.png";
import NCT5 from "../../Assessts/Images/AboutUs/Coreteam/NCT5.png";
import NCT6 from "../../Assessts/Images/AboutUs/Coreteam/NCT6.png";
import NCT7 from "../../Assessts/Images/AboutUs/Coreteam/NCT7.png";
import NCT8 from "../../Assessts/Images/AboutUs/Coreteam/NCT8.png";
import NCT9 from "../../Assessts/Images/AboutUs/Coreteam/NCT9.png";
import NCT10 from "../../Assessts/Images/AboutUs/Coreteam/NCT10.png";
import NCT11 from "../../Assessts/Images/AboutUs/Coreteam/NCT11.png";

import { Row, Col } from "react-bootstrap";
// import IOText from "../ReUableComponents/ImageOntext";
// import TBanner from "../Assessts/Images/Teams/Teams-Banner.png";
const Coreteam = () => {
  const NECPeople = [
    { img: NCT1, Name: "Dr. Chalasani Rao", Position: "Managing Trustee" },
    {
      img: NCT2,
      Name: "Mr. Baburao Sattharu",
      Position: "Sr. Manager – Scholarships Program",
    },

    {
      img: NCT4,
      Name: "Mr. Suhaas Yarramsetti",
      Position: "Sr. Manager - Fundraising",
    },
    {
      img: NCT6,
      Name: "Ms. S. Anitha",
      Position: "Program Associate Fundraising",
    },
    { img: NCT7, Name: "Mr. M. Chinna Rao", Position: "Office Manager" },
    {
      img: NCT3,
      Name: "Ms Archana Chamanti",
      Position: "Program Associate - Human Resources",
    },
    { img: NCT9, Name: "Mr. Sai Kumar", Position: "Office Associate" },
    {
      img: NCT5,
      Name: "Mr. Sumit kumar",
      Position: "Program Associate Communication",
    },
     {
      img: NCT10,
      Name: "Mr. Saikiraan Guduri",
      Position: "Sr Manager – Marketing",
    }, {
      img: NCT11,
      Name: "Mr. Vasu Kohli",
      Position: "Sr Manager -Technology Development",
    },
  ];
  //   const NACPeople = [
  //     {
  //       img: NAC1,
  //       Name: "Mr. Madhav Chavan",
  //       Position: "Co-Founder: Pratham Education Foundation",
  //     },
  //     { img: NAC2, Name: "Mr. T. B. Reddy", Position: "CEO: Reason Solutions" },
  //     {
  //       img: NAC3,
  //       Name: "Dr. J. P. Narayana",
  //       Position: "Founder: Foundation for Democratic Reforms",
  //     },
  //     { img: NAC4, Name: "Mr. Rao Chalasani", Position: "Founder & Mentor, NCP" },
  //     {
  //       img: NAC5,
  //       Name: "Ms. Smita Deorah",
  //       Position: "Co-Founder and Co-CEO: Lead Education Services",
  //     },
  //   ];
  //   const NCTPeople = [
  //     { img: NCT1, Name: "Mr. R. Tezaswy", Position: "Sr. Program Manager" },
  //     {
  //       img: NCT3,
  //       Name: "Mr. A. V. Govinda Rao",
  //       Position: "Chief Technical Advisor",
  //     },
  //     {
  //       img: NCT4,
  //       Name: "Ms. K. Padma",
  //       Position: "Program Manager - Implementation",
  //     },
  //     {
  //       img: NCT5,
  //       Name: "Ms. A. Sushmita",
  //       Position: "Program Manager – Content Development",
  //     },
  //     {
  //       img: NCT6,
  //       Name: "Mr. P. Krupakar Rao",
  //       Position: "Senior Program Associate (School Relations)",
  //     },
  //     { img: NCT7, Name: "Mr. Arjun Kumar", Position: "Technical Lead" },
  //     { img: NCT8, Name: "Ms. B. Sravanthi​", Position: "Program Associate - ​Implementation​​" },
  //     {
  //       img: NCT9,
  //       Name: "Ms. U. Chitra",
  //       Position: "Associate – Fundraising & Communications",
  //     },
  //     {
  //       img: NCT10,
  //       Name: "Ms. S. Anitha ",
  //       Position: "Program  Associate Fundraising",
  //     },
  //     {
  //       img: NCT11,
  //       Name: "Ms. R. Anitha ",
  //       Position: "Program  Associate - Content Development",
  //     },
  //   ];
  const Pagedata = [
    // { Data: NACPeople, Tittle: "NCP ADVISORY COUNCIL" },
    { Data: NECPeople, Tittle: "NSF India Core Team", color: "#F6F2ED" },
    // { Data: NCTPeople, Tittle: "NCP Core Team", color: "#EFFFFB" },
  ];
  return (
    <>
      {/* <IOText
        Image={TBanner}
        Alt="EMpower"
        Text={
          <div className="Text-MainDiv">
            <div>“Working Together to Advance Competency-Based Learning”</div>
            <div className="mt-2 Text-Content">
              <span style={{ color: "#F7D670" }}>
                {" "}
                Competency based learning{" "}
              </span>{" "}
              &gt; Team
            </div>
          </div>
        }
      /> */}
      {Pagedata.map((Team) => (
        <>
          <div
            className="container-fluid pb-4"
            style={{ backgroundColor: `${Team?.color}` }}
          >
            <div className="Web-MainHeading pt-4 pb-4">{Team.Tittle}</div>
            <Row>
              {Team.Data.map((item) => (
                <Col className="dflex JCCenter Team-each">
                  <Images
                    Image={item.img}
                    Name={item.Name}
                    Position={item.Position}
                  />
                </Col>
              ))}
            </Row>
          </div>
        </>
      ))}
    </>
  );
};
export default Coreteam;
